import React, {useCallback, useEffect} from 'react';
import {some, sortBy, map, groupBy, isEmpty} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {newActivity} from 'shared/portfolio/actions/activities';
import {Store} from 'src/types/store';
import Section from '../section';
import EmptyPlaceholder from '../empty-placeholder';
import PortfolioSectionHeader from '../portfolio-section-header';
import ActivityCard from './activities-card';
import PortfolioIcon from '../portfolio-icon/portfolio-icon';

const TYPE_TO_TITLE_MAP = {
  activity: 'Activities',
  sport: 'Sports',
};

const Activities = () => {
  const mq = useMediaQuery();
  const dispatch = useDispatch();
  const activities = useSelector((state: Store) => state.activities);
  const editing = some(activities, (activity) => activity.editing);
  const sortedActivities = sortBy(activities, (activity) => -activity.createdAt);
  const groupedActivities = groupBy(sortedActivities, 'activityType');
  const handleAddClick = useCallback(() => dispatch(newActivity()), [dispatch]);

  useEffect(() => {
    window.Raise.vent.on('add:activity', handleAddClick);
  }, [handleAddClick]);

  return (
    <div>
      <PortfolioSectionHeader
        addNew={handleAddClick}
        displayNew={!editing && !(mq.XS && !Object.keys(activities).length)}
        title="Extracurriculars"
        sectionName="activities"
      >
        <PortfolioIcon type="activities" size={mq.XS ? 40 : 56} />
      </PortfolioSectionHeader>
      <div id="activities" className="portfolio-sections main-section"></div>
      {isEmpty(groupedActivities) ? (
        <Section>
          <div className="portfolio-sections column">
            <EmptyPlaceholder
              header="Add an Activity"
              description="Up to $1,000 per year"
              onClick={handleAddClick}
              portfolioItemType="activities"
            />
          </div>
        </Section>
      ) : (
        map(groupedActivities, (activityList, group) => (
          <ActivityCard
            key={`portfolio-${group}`}
            activities={activityList}
            activityType={TYPE_TO_TITLE_MAP[group]}
          />
        ))
      )}
    </div>
  );
};

export default Activities;
